import { FlexSpinner, onFormatDate } from 'components'
import {
  FormikMultiUserPicker,
  MultiPersonPickerProps,
} from 'components/PersonPicker'
import { FieldProps } from 'formik'
import { AuthorizedField as Field } from 'forms/AuthorizedField'
import { FieldStack, FormStack } from 'forms/FormStack'
import _ from 'lodash'
import * as model from 'model'
import {
  IDropdownOption,
  IPersonaProps,
  Label,
  Stack,
  Text,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDoubleBookingsParticipantsQuery } from 'views/ProvingDetailsView/hooks'
import * as Yup from 'yup'

export type ProvingDetailsParticipantFormValues = { personIds: string[] } & {
  personType: string
}
export class ProvingDetailsParticipantFormSchema {
  constructor() {
    return Yup.object().shape({
      personType: Yup.string(),
      personIds: Yup.array().when('personType', {
        is: 'user',
        then: Yup.array().required(),
      }),
    })
  }
}

export const ProvingDetailsParticipantForm: React.FC<{
  proving: Partial<model.Proving>
  orderIds: string[]
}> = ({ proving, orderIds }) => {
  const { t } = useTranslation()
  // const [state, setState] = useState()
  const [resultArray, setResultArray] = useState<any[]>([])
  const { data, loading, error } = useDoubleBookingsParticipantsQuery()
  // const [selectionPEG, setSelectionPEG] = React.useState([] as UserPersona[])
  // const [selectionSupplier, setSelectionSupplier] = React.useState(
  //   [] as UserPersona[]
  // )
  // const maskFormat: { [key: string]: RegExp } = {
  //   '9': /[1-9]/,
  // }
  const result =
    !loading && data && data.cachedProvings ? data.cachedProvings : []

  // const options: IDropdownOption[] = [
  //   { key: 'user', text: t('dropdown.option.pag') },
  //   // { key: 'pPEG', text: t('dropdown.option.pPEG') },
  //   // { key: 'pSupplier', text: t('dropdown.option.pSupplier') },
  //   // { key: 'pNewSupplier', text: t('dropdown.option.pNewSupplier') },
  //   // { key: 'pUnknown', text: t('dropdown.option.pUnknown') },
  //   // { key: 'pGroup', text: t('dropdown.option.pGroup') },
  //   // { key: 'pFromProving', text: t('dropdown.option.pFromProving') },
  // ]

  const workerAmountOptions: IDropdownOption[] = []
  _.times(10, (i) =>
    workerAmountOptions.push({
      key: i + 1,
      text: _.toString(i + 1),
    })
  )

  // const resetParticipants = (fieldProps: FieldProps<any>) => {
  //   fieldProps.form.setFieldValue('participants', [])
  // }

  const checkForDoublebooking = (ppl: IPersonaProps[] | undefined) => {
    const doublebookings = [] as any[]
    const people = ppl || []
    result.forEach((prov) =>
      (prov.participants || []).forEach((participant) => {
        people.forEach((peppbles) => {
          if (
            participant &&
            peppbles &&
            (participant.person ? participant.person._id : '') ===
              (peppbles as any).userId
          ) {
            if (
              participant.dateFrom <= proving.dateTo &&
              participant.dateTo >= proving.dateFrom
            ) {
              doublebookings.push({
                provingGroundTitle: prov.provingGround!.title,
                provingDescription: prov.title,
                provingNr: prov.id,
                person: participant,
              })
            }
          }
        })
      })
    )
    setResultArray(doublebookings)
  }

  return (
    <FlexSpinner loading={loading} error={error}>
      <FormStack>
        <>
          <Label>{t('model.proving.participant.addParticipant')}</Label>
          {/* <FieldStackItem
            name={`personType`}
            render={(
              fieldProps: FieldProps<ProvingDetailsParticipantFormValues>
            ) => (
              <FormikDropdown
                label={t('field.participantType.label')}
                {...fieldProps}
                options={options}
                onChanged={option => {
                  setState(option.key)
                  resetParticipants(fieldProps)
                }}
                required={true}
              />
            )}
          /> */}

          {/* {state === 'user' && ( */}
          {/* <> */}
          <FieldStack>
            <Stack.Item className="composite-field">
              <Field
                name={`personIds`}
                required={true}
                render={(fieldProps: FieldProps<MultiPersonPickerProps>) => (
                  <FormikMultiUserPicker
                    {...fieldProps}
                    onChange={(x) => checkForDoublebooking(x)}
                  />
                )}
              />
            </Stack.Item>
          </FieldStack>
          {/* </> */}
          {/* )} */}
          {resultArray && resultArray.length > 0 && (
            <FieldStack>
              <Text variant="xLarge" as="h2">
                ACHTUNG!
              </Text>
              <Stack.Item>
                <Label>
                  {t(
                    `Folgender Teilnehmer ist zum Zeitraum ${onFormatDate(
                      new Date(proving.dateFrom)
                    )} bis ${onFormatDate(
                      new Date(proving.dateTo)
                    )} bereits gebucht`
                  )}
                </Label>
                {resultArray.map((x: any, i: number) => {
                  return (
                    <FieldStack key={i}>
                      <Label>{x.person.person.name}</Label>
                      <table>
                        <tbody>
                          <tr>
                            <td>Standort: {x.provingGroundTitle}</td>
                          </tr>
                          <tr>
                            <td>Erprobungsnr.: {x.provingNr}</td>
                          </tr>
                          <tr>
                            <td>Erprobung: {x.provingDescription}</td>
                          </tr>
                          <tr>
                            <td>Abteilung: {x.person.department}</td>
                          </tr>
                          <tr>
                            <td>
                              Datum: {onFormatDate(new Date(x.person.dateFrom))}{' '}
                              bis {onFormatDate(new Date(x.person.dateTo))}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <hr />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </FieldStack>
                  )
                })}
                <Label>
                  {t('Möchten Sie den Teilnehmer trotzdem buchen?')}
                </Label>
              </Stack.Item>
            </FieldStack>
          )}
        </>
      </FormStack>
    </FlexSpinner>
  )
}
